import { Link } from 'react-router-dom';
import Reveal from '@/pages/zz-review/components/Reveal';

export default function FounderSection() {
  return (
    <section id="founder" className="w-full scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 text-center md:px-6">
        <Reveal>
          <p className="mb-3 text-xs tracking-[0.2em] text-foreground-400">作者與源流</p>
          <h2 className="text-2xl text-foreground-900 md:text-4xl" style={{ fontFamily: 'var(--font-heading)' }}>ABAA Wu</h2>
          <p className="mx-auto mt-6 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
            《1001旋轉門》來自 ABAA 數十年在航太科技管理、企業教育、生命實踐與文明架構中的累積。她的完整生命經歷、第一人稱任務見證與歷史資料，已獨立於書籍介紹之外。
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
            ABAA 留下源流、書籍、方法、驗證標準與必要節點覆核；目的不是讓人追隨一位永久領導者，而是讓每個人在自己的位置上成熟、承擔，成為宇宙生命樹不同層次的管道。
          </p>
          <Link to="/abaa-witness" className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 hover:bg-primary-600">
            閱讀 ABAA 完整經歷見證
            <i className="ri-arrow-right-line" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
